import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	searchAllArticlesCta: {
		id: 'servicedesk.knowledge-hub.common.search-knowledge-inline.search-knowledge-inline-stateless.search-all-articles-cta',
		defaultMessage: 'Search all articles for {term}',
		description: 'Call to action to search over all articles',
	},
	searchIconLabel: {
		id: 'servicedesk.knowledge-hub.common.search-knowledge-inline.search-knowledge-inline-stateless.search-icon-label',
		defaultMessage: 'search icon',
		description: 'label for icon displaying that this is a search box',
	},
});
